module.exports = __webpack_public_path__ + "static/media/macomb-FAB.487a3cf5.svg";